import React, { useRef, useState } from "react";

import MaskedInput from "antd-mask-input";

import { parseInputRules } from "utils";

import { Form, InputLabel } from "components";

export const InputMasked = ({
  allowClear,
  className = "",
  mask,
  maskOptions,
  name,
  label,
  message,
  rules,
  initialValue,
  disabled,
  placeholder,
  dataTestId,
  onBlur = () => {},
  onChange = () => {},
}) => {
  const inputElement = useRef(null);
  const [hasBeenFocused, setHasBeenFocused] = useState(false);
  const [internalValue, setInternalValue] = useState(initialValue);
  const [status, setStatus] = useState("validating");

  const handleBlur = (v) => {
    setHasBeenFocused(false);
    onBlur(v);

    if (v.includes("_")) {
      setStatus("error");
    } else {
      setStatus("success");
    }
  };

  const handleChange = (v) => {
    setInternalValue(v);
    onChange(v);
  };

  const handleLabelClick = () => {
    setHasBeenFocused(true);
    inputElement.current.focus();
  };

  const active = hasBeenFocused || internalValue;
  const required = rules && rules[0] && rules[0].required;

  return (
    <Form.Item
      className={`floating-input ${hasBeenFocused ? "active" : ""} ${disabled ? "disabled" : "message"} ${className}`}
      colon={false}
      label={<InputLabel active={active} required={required} label={label} handleClick={handleLabelClick} />}
      name={name}
      rules={parseInputRules(rules, message)}
      initialValue={initialValue}
      validateStatus={status}
    >
      <MaskedInput
        data-testid={dataTestId}
        allowClear={allowClear}
        disabled={disabled}
        mask={mask}
        maskOptions={maskOptions}
        placeholder={placeholder}
        ref={inputElement}
        onChange={({ target }) => handleChange(target.value)}
        onFocus={() => setHasBeenFocused(true)}
        onBlur={({ target }) => handleBlur(target.value)}
      />
    </Form.Item>
  );
};
